import Grid from '@mui/material/Grid';
import { changeStatusTicket } from '_models/redux/change-status/actions';
import { getCustomerProfile } from '_models/redux/customer-profile/action';
import { getStatusList } from '_models/redux/get-status/action';
import { getTicketById } from '_models/redux/get-ticket-by-id/action';
import { connect } from 'react-redux';
import { helpdeskDetailContext } from '../data/helpdesk-detail-context';
import TicketIncidenceInfo from './HelpdeskIncidenceInfoComponent';
import IncidenceTimeCounter from './HelpdeskIncidenceTimecounterComponent';
import CustomerProfileHeaderIncidence from './HelpdeskProfileHeaderComponent';

const HelpDeskDetailPage = () => {
  const helpdeskValues = {};

  return (
    <helpdeskDetailContext.Provider value={helpdeskValues}>
      <Grid container>
        <Grid item size={{ xs: 9 }} className='tabs-container'>
          <IncidenceTimeCounter />
        </Grid>
        <Grid item size={{ xs: 3 }} className='ticket-bar'>
          <TicketIncidenceInfo />
          <CustomerProfileHeaderIncidence />
        </Grid>
      </Grid>
    </helpdeskDetailContext.Provider>
  );
};

const mapStateToProps = (state) => ({
  customerProfileReducer: state.customerProfile,
  incidence: state.incidence,
  statusList: state.statusList,
  changeStatusTicket: state.changeStatusTicket,
  ticketById: state.ticketById,
});
const mapDispatchToProps = {
  getCustomerProfile,
  getTicketById,
  getStatusList,
  changeStatusTicket,
};

export default connect(mapStateToProps, mapDispatchToProps)(HelpDeskDetailPage);
